var map = {
	"./apple.svg": "f9d5",
	"./arrow_down.svg": "4b1a",
	"./arrow_left_small.svg": "3911",
	"./arrow_right_long.svg": "398d",
	"./arrow_right_small.svg": "97b1",
	"./arrow_up.svg": "1ad6",
	"./background.svg": "1473",
	"./balance.svg": "75c6",
	"./benefits_check.svg": "f34f",
	"./bsc.svg": "da4a",
	"./card-menu.svg": "e26c",
	"./card_error.svg": "137c",
	"./card_pending.svg": "e7db",
	"./card_success.svg": "4119",
	"./challenge.svg": "53d4",
	"./chart.svg": "2f02",
	"./check_email_modal.svg": "91b9",
	"./clock.svg": "755b",
	"./confirm_modal.svg": "5b78",
	"./cosmos.svg": "db33",
	"./cross.svg": "2ad7",
	"./cross_black.svg": "4177",
	"./cross_qr.svg": "725f",
	"./cross_white.svg": "4633",
	"./crypto_logo.svg": "5e36",
	"./dashboard.svg": "ecef",
	"./dropdown_arrow.svg": "e7f5",
	"./error.svg": "28c3",
	"./error_modal.svg": "2695",
	"./flag.svg": "c26e",
	"./freeze.svg": "f138",
	"./freeze_unlock.svg": "a6e6",
	"./google.svg": "d950",
	"./hidden-password.svg": "737a",
	"./icon_search.svg": "b654",
	"./info_circle.svg": "dace",
	"./info_message.svg": "7bbb",
	"./input-info.svg": "37ce",
	"./like.svg": "6d8b",
	"./like_count.svg": "c61d",
	"./like_disabled.svg": "997d",
	"./like_filled.svg": "f6e9",
	"./loader_button.svg": "f48d",
	"./logo_sidebar.svg": "027c",
	"./menu_button.svg": "1fa1",
	"./menu_button_close.svg": "9311",
	"./modal_cross.svg": "3476",
	"./profile_id.svg": "29cb",
	"./profile_next.svg": "1e41",
	"./profile_rank.svg": "5079",
	"./profile_total.svg": "7086",
	"./referral.svg": "5a66",
	"./refresh.svg": "53fa",
	"./security.svg": "5f0d",
	"./set_2fa.svg": "b70a",
	"./settings.svg": "9174",
	"./source_address.svg": "4a88",
	"./srcx_address.svg": "04dd",
	"./success.svg": "1c27",
	"./total.svg": "fa67",
	"./unset_button.svg": "d6d5",
	"./visible-password.svg": "e516",
	"./withdrawal_button_icon.svg": "903f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";